import React, { useEffect, useState } from "react";
import { useRoleVerify } from "Common/RoleVerify";
import { getAllRoomOffer } from "adminApi/AssignRoomOfferApi/AssignRoomOffer";
import DataTable from "Common/DataTable/DataTable";
import useTableConfig from "Hooks/useTableConfig";
import { generateDisplayFields } from "utils/fieldMapper";
import feilds from "./json/AssignRoomOfferFields.json";
import Spinner from "Common/Globle/Spinner";

const RoomOfferListTable = ({ month, year }) => {
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [data, setData] = useState([]);
    const canShowAction = useRoleVerify("", ["can_edit", "can_delete"]);
    const sizeOptions = [''];
    const { tabledata } = feilds

    useEffect(() => {
        const fetchRoomOffers = async () => {
            try {
                setLoading(true);
                const res = await getAllRoomOffer({ month_year: `${year}-${month}` });
                if (res.success) {
                    setData(res.data);
                }
            } catch (error) {
                setError(true);
                console.error("Get All Room Offer List API Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchRoomOffers();
    }, [month, year]);

    const displayFields = generateDisplayFields(tabledata);

    const FilterData = data.map((item) => ({
        ...item,
        offer_date: item.offer_date.split('T')[0]
    }));

    // Table Hook
    const { formattedData, columns } = useTableConfig({
        data: FilterData,
        page,
        limit,
        canShowAction,
        IsEdit: false,
        IsDelete: false,
        IsModel: {
            val: 'Copy/Edit',
            show: true
        },
        config: {
            idKey: "offer_id",
            editUrl: "copy-assign-offer",
            displayFields,
        },
    });

    const handleSearch = (val, resetPage = null) => {
        setSearch(val);
        if (resetPage !== null) setPage(resetPage);
    };

    const onPageChange = (p) => setPage(p);

    const onLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
    };

    return (
        <>
            {loading && <Spinner isSpinner={true} />}
            <DataTable
                columns={columns}
                data={formattedData}
                options={{
                    loading,
                    error,
                    sortableColumns: displayFields.map((f) => f.accessor),
                    copy: true,
                    csv: true,
                    pdf: true,
                    print: true,
                }}
                Search={{
                    search: false,
                    SearchInputValue: search,
                    handleSearch: handleSearch,
                }}
                Entries={{
                    Entries: false,
                    limit,
                    onLimitChange,
                    options: sizeOptions,
                }}
                pagination={{
                    isActive: false,
                    meta: {},
                    onPageChange,
                }}
            />
        </>
    );
};

export default RoomOfferListTable;
